import { render, staticRenderFns } from "./itemConfiguration.vue?vue&type=template&id=365c8572&"
import script from "./itemConfiguration.vue?vue&type=script&lang=js&"
export * from "./itemConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./itemConfiguration.vue?vue&type=style&index=0&id=365c8572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports